import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearMappingBackUrl} from "../config/crystalclear-mapping-back-url";
import {SrcMappingAccountCode} from "../../model/mapping/src-mapping-account-code";
import {SrcMappingBrokerCode} from "../../model/mapping/src-mapping-broker-code";
import {SrcMappingFee} from "../../model/mapping/src-mapping-fee";
import {SrcMappingContract} from "../../model/mapping/src-mapping-contract";
import {SrcMappingExchange} from "../../model/mapping/src-mapping-exchange";
import {SrcMappingTrader} from "../../model/mapping/src-mapping-trader";
import {SrcMappingTradeType} from "../../model/mapping/src-mapping-trade-type";

@Injectable({
  providedIn: 'root'
})
export class MappingSrcMappingTradeTypeService extends CommonCrudService<SrcMappingTradeType> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearMappingBackUrl.GET_MAPPING_SRCMAPPINGTRADETYPE_LIST,
      CrystalclearMappingBackUrl.SAVE_MAPPING_SRCMAPPINGTRADETYPE,
      CrystalclearMappingBackUrl.DELETE_MAPPING_SRCMAPPINGTRADETYPE);
  }

}
